// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"88850ea8b925f5d9cdf6","feed-creation-page":"194ffda2a58153163244","feed-manager-page":"d66fe6c5bdbddb497c2b"}[chunkId] + ".js";
};